import React from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";

export const InputDescription = ({ value, onChange }) => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  return (
    <input
      className={styles.root}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={t("content.placeholder.description")}
    />
  );
};
